module.exports = __webpack_public_path__ + "static/media/quote-icon.570e9fdf.svg";